<template>
  <div class="form__alert">
    <div>
      <span><div class="alert__icon"></div></span>
    </div>
    <div>
      <p class="alert__title">¡Solicitud recibida!</p>
      <ul v-if="isWorkHour" class="alert__messages">
        <li class="alert__item">En breve te llamaremos para guiarte en tu viaje hipotecario.</li>
        <li class="alert__item">Estamos disponibles cuando tú quieras en el 910 054 391.</li>
      </ul>
      <div v-else class="alert__messages">
        <p class="alert__item">Nuestro horario de atención es (horario peninsular):</p>
        <ul class="alert__messages">
          <li class="alert__item alert__item--bold">lunes - jueves: 9h a 21h</li>
          <li class="alert__item alert__item--bold">viernes: 9h-20h</li>
          <li class="alert__item alert__item--bold">sábados y domingos: 9h a 18h</li>
        </ul>
        <div class="alert__thanks">
          <p class="alert__item">Comenzaremos a trabajar en tu solicitud a la brevedad.</p>
          <p class="alert__item">¡Gracias por contactar con nosotros!</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isWorkHour: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
